module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid33_980x852.a32a0ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid33_980x852.jpg
// module id = w2Ff
// module chunks = 0